<div *ngIf="allAssets && selectedAssets && allAssetGroups" class="m-portlet mb-0">
    <div class="m-portlet__head">
        <div class="m-portlet__head-caption">
            <div class="m-portlet__head-title">
                <h3 class="m-portlet__head-text" i18n="@@9812fc57023245b7b63d532e3da22a7763ddde33">Prostori</h3>
            </div>
        </div>
    </div>
    <div class="m-portlet__body">
        <div class="m-checkbox-list">
            <label
                class="m-checkbox m-checkbox--state-brand"
                [ngClass]="{
                    'ml-2': allAssetGroups.length === 1
                }"
            >
                <input
                    [checked]="allAssets?.length === selectedAssets?.length && selectedAssets?.length !== 0"
                    (change)="selectAllAssets($event)"
                    type="checkbox"
                    i18n="@@0be9fda4-64f5-572b-8256-77fe2cd3b07c"
                />
                Označi vse
                <span></span>
            </label>
            <div *ngFor="let group of allAssetGroups">
                <span *ngIf="allAssetGroups.length !== 1">
                    <label class="m-checkbox m-checkbox--state-brand">
                        <input
                            [checked]="allSelected(group.group)"
                            (change)="onChangeSelectLocal(group?.data, $event, group?.group)"
                            type="checkbox"
                            i18n="@@2274133190639616"
                        />
                        {{ group?.label }}
                        <span></span>
                    </label>
                </span>
                <label
                    *ngFor="let asset of group?.data"
                    class="m-checkbox"
                    [ngClass]="{
                        'ml-4': allAssetGroups.length !== 1,
                        'ml-2': allAssetGroups.length === 1
                    }"
                >
                    <input
                        [checked]="checkIfSelectedAsset(asset)"
                        (change)="changeAssetFilter($event, asset)"
                        type="checkbox"
                        value="{{ asset.id }}"
                    />
                    <div class="fc-unthemed">{{ asset.name }}</div>
                    <span></span>
                </label>
            </div>
        </div>
    </div>
</div>
